import _map from 'lodash/map';
import _orderBy from 'lodash/orderBy';
import _mapValues from 'lodash/mapValues';
import _find from 'lodash/find';

import { defaultIconsColor } from 'core/constants';

export const newCardPrototype = (cardData) => {
  return {
    title: cardData.title,
    type: cardData.type,
    collapsed: false,
    height: 200,
    sidebarHeight: 150,
    boardHeight: 200,
    labels: cardData.labels ? cardData.labels : [],
    color: cardData.color ? cardData.color : defaultIconsColor,
    body: cardData.body ? cardData.body : '',
  }
}

export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const newResult = _orderBy(result, 'position', 'asc');
  const [removed] = newResult.splice(startIndex, 1);
  newResult.splice(endIndex, 0, removed);
  return newResult;
};

export const insertItemToArr = (arr, newItem, index) => [
  ...arr.slice(0, index),
  newItem,
  ...arr.slice(index),
];

export const findColIdByItem = (columns, itemId) => {
  let colId = null;
  _mapValues(columns, (col) => {
    const hasCard = col.data.some((item) => item.id === itemId);
    if (hasCard) colId = col.id;
  });
  return colId;
};
/**
 * Moves an item from one list to another list.
 */
export const move = (
  source,
  destination,
  droppableSource,
  droppableDestination
) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = {
    data: sourceClone,
    id: droppableSource.droppableId,
  };
  result[droppableDestination.droppableId] = {
    data: destClone,
    id: droppableDestination.droppableId,
  };

  return result;
};

export const moveOnBoard = (board, droppableSource, droppableDestination) => {
  const sourceClone = board.find((col) => col.id === droppableSource.parentId);
  const destClone = board.find(
    (col) => col.id === droppableDestination.parentId
  );
  
  const sourceCol = sourceClone.columns.find(
    (sCol) => sCol.id === droppableSource.droppableId
  );
  const destCol = destClone.columns.find(
    (sCol) => sCol.id === droppableDestination.droppableId
  );

  const [removed] = sourceCol.data.splice(droppableSource.index, 1);

  destCol.data.splice(droppableDestination.index, 0, removed);

  // const result = board.map((col) => {
  //   if (col.id === sourceClone.id)
  //     return col.map((sCol) =>
  //       sCol.id === sourceClone.id ? { ...sourceClone, columns: [...sourceCol] } : { ...sCol }
  //     );
  //   if (col.id === destClone.id)
  //     return col.map((sCol) =>
  //       sCol.id === destCol.id ? { ...destCol, columns: [...destCol] } : { ...sCol }
  //     );
  //   return col;
  // });

  return board;
};

export const getCardsByList = (list, cards) => {
  return _map(cards, card => 
    _find(list, stateCard => stateCard.id === card)
  )
}

export const getCardById = (getState, cardId) => {
  return _find(getState().firestore.ordered.myCards, (card) => card.id === cardId);
}
